import React, { useState } from "react";
import { Container, Row, Col, Dropdown, Breadcrumb } from "react-bootstrap";
import { FiCalendar, FiFileText, FiChevronUp } from "react-icons/fi";
import DatePicker from "react-datepicker";

import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FiChevronDown } from "react-icons/fi";
import { LuFileText } from "react-icons/lu";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EmployeeStatusChart from "../../../components/Dashboard/hr-dashboard/EmployeeStatusChart";
import OverviewStatistics from "../../../components/Dashboard/hr-dashboard/OverviewStatistics";
import AttendanceTrend from "../../../components/Dashboard/hr-dashboard/AttendanceTrend";
import EmployeeDistribution from "../../../components/Dashboard/hr-dashboard/EmployeeDistribution";
import LateArrivals from "../../../components/Dashboard/hr-dashboard/LateArrivals";
import RecruitmentStatistics from "../../../components/Dashboard/hr-dashboard/RecruitmentStatistics";
import UpcomingInterviews from "../../../components/Dashboard/hr-dashboard/UpcomingInterviews";
import LeftDashboard from "../../../components/Dashboard/hr-dashboard/LeftDashboard";
import RightDashboard from "../../../components/Dashboard/hr-dashboard/RightDashboard";
const HRDashboardPage = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date(2026, 2, 10));
  return (
    <div style={{ padding: "15px", background: "#f8f9fa" }}>
      <Container fluid className="mb-3">
        <Row className="align-items-center justify-content-between flex-wrap">
          <Col md={4} sm={12}>
            <div className="my-auto mb-2">
              <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
                HR Dashboard
              </h4>

              <Breadcrumb
                style={{
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  fontSize: "14px",
                }}
              >
                <Breadcrumb.Item>
                  <RiHome6Line
                    className="m text-dark"
                    style={{
                      fontSize: "1.2rem", // increased icon size
                      verticalAlign: "middle",
               
                    }}
                  />
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item
                  linkAs="span"
                  className="text-dark text-decoration-none fs-6"
                >
                  Dashboard
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item active>
                  <span className="text-dark fs-6">HR-Dashboard</span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </Col>

          {/* RIGHT SIDE */}
          <Col md="auto" className="d-flex align-items-center flex-wrap gap-3">
            {/* AVATAR GROUP */}
            <div className="avatar-group">
              <img
                src="/assets/img/users/user-31.jpg"
                className="avatar"
                alt=""
              />
              <img
                src="/assets/img/users/user-32-1.jpg"
                className="avatar"
                alt=""
              />
              <img
                src="/assets/img/users/user-29-1.jpg"
                className="avatar"
                alt=""
              />
              <img
                src="/assets/img/users/user-56.jpg"
                className="avatar"
                alt=""
              />

              <div className="avatar add-avatar">+</div>
            </div>

            {/* DATE PICKER */}
            <div className="d-flex align-items-center gap-3 flex-wrap">
              {/* DATE RANGE */}
              <div className="date-range-box d-flex align-items-center">
                <FiCalendar className="me-2 text-secondary" size={18} />

                <DatePicker
                  selected={startDate}
                  onChange={(dates) => {
                    const [start, end] = dates;
                    setStartDate(start);
                    setEndDate(end);
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  dateFormat="MM/dd/yyyy"
                  className="date-input-field"
                />
              </div>

              {/* YEARLY REPORT */}
              <Dropdown>
                <Dropdown.Toggle className="yearly-btn d-flex align-items-center text-dark no-arrow">
                  <LuFileText className="me-2" size={18} />
                  Yearly Report
                  <FiChevronDown className="ms-2" />
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                  <Dropdown.Item>Monthly Report</Dropdown.Item>
                  <Dropdown.Item>Yearly Report</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* ADD NEW */}
              <Dropdown>
                <Dropdown.Toggle className="add-btn no-arrow">
                  Add New <FiChevronDown className="ms-2" />
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                  <Dropdown.Item>Employee</Dropdown.Item>
                  <Dropdown.Item>Attendance</Dropdown.Item>
                  <Dropdown.Item>Leave</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {/* COLLAPSE ICON */}
            <div className="collapse-icon">
              <FiChevronUp size={20} />
            </div>
          </Col>
        </Row>
      </Container>

      <Col className="mt-2">
        <Row className="g-3">
          <Col lg={5} md={12} className="d-flex">
            <EmployeeStatusChart />
          </Col>

          <Col lg={7} md={12} className="d-flex">
            <OverviewStatistics />
          </Col>
        </Row>
      </Col>

      <Col>
        <Row>
          <Col lg={8} md={12} className="d-flex">
            <AttendanceTrend />
          </Col>

          <Col lg={4} md={12} className="d-flex">
            <EmployeeDistribution />
          </Col>
        </Row>
      </Col>
      <Row className="g-3 mt-2">
        <Col xl={4} lg={6}>
          <LateArrivals />
        </Col>

        <Col xl={4} lg={6}>
          <RecruitmentStatistics />
        </Col>

        <Col xl={4}>
          <UpcomingInterviews />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xl={7}>
          <LeftDashboard className="d-flex" />
        </Col>

        <Col xl={5}>
          <RightDashboard className="d-flex" />
        </Col>
      </Row>

      <style>
        {`

.date-range-box {
  border: 1px solid #e5e7eb;
  padding: 8px 14px;
  border-radius: 8px;
  background: white;
  min-width: 230px;
}

.date-input-field {
  border: none;
  outline: none;
  font-size: 14px;
  width: 170px;
}

.yearly-btn {
  border: 1px solid #e5e7eb;
  background: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 500;
}

.yearly-btn:hover {
  background: #f8f9fa;
}

.add-btn {
  background: #ff6b1a !important;
  border: none !important;
  padding: 8px 18px;
  border-radius: 8px;
  color: white !important;
  font-weight: 500;
}

.add-btn:hover {
  background: #e95e13 !important;
}
.avatar-group {
  display: flex;
  align-items: center;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid white;
  margin-left: -10px;
  object-fit: cover;
}

.avatar:first-child {
  margin-left: 0;
}

.add-avatar {
  background: #212529;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
}
.dropdown-toggle::after {
  display: none !important;
}
.date-input {
  width: 220px;
}

.calendar-icon {
  position: absolute;
  left: 10px;
  top: 9px;
  color: gray;
}

.collapse-icon {
  cursor: pointer;
  padding: 6px;
}

@media (max-width: 768px) {
  .date-input {
    width: 180px;
  }
}


`}
      </style>
    </div>
  );
};

export default HRDashboardPage;
